import { render, staticRenderFns } from "./shopFollowData.vue?vue&type=template&id=6f929976&"
import script from "./shopFollowData.vue?vue&type=script&lang=js&"
export * from "./shopFollowData.vue?vue&type=script&lang=js&"
import style0 from "./shopFollowData.vue?vue&type=style&index=0&id=6f929976&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports